import { Collapse as AntdCollapse, CollapsePanelProps } from 'antd'

export const Panel = (props: CollapsePanelProps) => (
  <AntdCollapse.Panel {...props} />
)
